export enum RouteType {
  Auth = 'auth',
  Protected = 'protected',
  Default = 'default',
}

export enum RoutesEnum {
  AccessTags = '/access-tags',
  Home = '/',
  Iterations = '/iterations',
  GeotagGeneration = '/geotag-generation',
  Layers = '/layers',
  Login = '/login',
  ChangePassword = '/login/change-password',
  TwoFactorVerification = '/2fa/verify',
  TwoFactorSetup = '/2fa/setup',
  Logout = '/logout',
  Map3D = '/3d-map',
  Map3DWorkspace = '/3d-map/:workspaceId?',
  MergedDataset = '/merged-dataset',
  NetworkError = '/network-error',
  PageNotFound = '/not-found',
  Processing = '/processing',
  ProcessingRoutes = '/processing/*', // Route all child paths of processing to processing element.
  Projects = '/projects',
  PrivacyPolicy = '/privacy-policy',
  Reports = '/reports',
  Sites = '/sites',
  Storage = '/files',
  SwipeMap = '/swipe-map',
  SwipeMap3D = '/3d-swipe-map',
  Tasks = '/tasks',
  MicrosoftAuthRedirect = '/auth/microsoft-redirect',
  UnAuthorizedSSO = '/sso-not-authorized',
  UserGroups = '/user-groups',
  Users = '/users',
  Segmentation = '/segmentation',

  // Dashboard Module.
  Dashboard = '/dashboard',
  DashboardProductivity = 'productivity',
  DashboardProductivityVolume = 'volume',
  DashboardProductivityLeadDistance = 'lead-distance',
  DashboardProductivityFiles = 'files',
  DashboardPlanVsActual = 'plan-vs-actual',
}

export enum TabNames {
  Layers = 'layers',
  Tasks = 'tasks',
  Iterations = 'iterations',
  MergedDataset = 'merged-dataset',
}
